<app-breadcrumb
  [title]="'Nuevo Cotización'"
  [items]="['Comercial', 'Cotizaciones']"
  [active_item]="'Nuevo cotizaciones'"
>
</app-breadcrumb>

<div class="card">
  <div class="card-header d-flex align-items-center bg-primary text-white">
    <i class="icofont icofont-verification-check me-2"></i>
    <h5 class="mb-0">Datos del cliente</h5>
  </div>

  <div class="card-body">
    <form ngNativeValidate>
      <div class="row g-3">
        <div class="col-md-3 mb-3">
          <label class="form-label" for="startDate">Fecha de realización</label>
          <div class="input-group input-group-sm">
            <input class="form-control" placeholder="yyyy-mm-dd" name="startDate" [(ngModel)]="fromDate" ngbDatepicker #d1="ngbDatepicker" [placement]="placement" (focus)="fromDate = null" />
            <button class="btn btn-primary calendar" (click)="d1.toggle()" type="button">
              <app-feather-icons [icon]="'calendar'"></app-feather-icons>
            </button>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            Realiza por:</label
          >
          <ng-select [items]="Realizado" placeholder="Selecciona una opción"
          class="js-example-placeholder-multiple" [(ngModel)]="realizado"></ng-select>
          <div class="valid-feedback">Looks good!</div>
        </div>
      </div>
      <div class="row g-3 mt-3">
        <div class="col-md-3">
          <label class="form-label" for="validationCustom01"> 
            Cliente:</label>
          <ng-select [items]="Cliente" placeholder="Selecciona una opción"
          class="js-example-placeholder-multiple" [(ngModel)]="cliente"></ng-select>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            Documento:</label
          >
          <input
            class="form-control"
            id="validationCustom01"
            type="number"
            placeholder="First name"
            required=""
            onlyAlphabets
          />
          <div class="valid-feedback">Looks good!</div>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            Nombre cliente:</label
          >
          <input
            class="form-control"
            id="validationCustom01"
            type="text"
            placeholder="First name"
            required=""
            onlyAlphabets
          />
          <div class="valid-feedback">Looks good!</div>
        </div>

        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            Dirección cliente</label
          >
          <input
            class="form-control"
            id="validationCustom01"
            type="text"
            placeholder="First name"
            required=""
            onlyAlphabets
          />
          <div class="valid-feedback">Looks good!</div>
        </div>
      </div>
      <div class="row g-3 mt-3">
        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            Teléfono cliente:</label
          >
          <input
            class="form-control"
            id="validationCustom01"
            type="number"
            placeholder="First name"
            required=""
            onlyAlphabets
          />
        </div>

        <div class="col-md-3">
          <label class="form-label" for="validationCustom01">
            E-mail cliente:</label
          >
          <input
            class="form-control"
            id="validationCustom01"
            type="number"
            placeholder="First name"
            required=""
            onlyAlphabets
          />
          <div class="valid-feedback">Looks good!</div>
        </div>
      </div>
    </form>
  </div>
</div>

<div class="card">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-verification-check me-2"></i>
      <h5 class="mb-0">Datos del cliente</h5>
    </div>
  
    <div class="card-body">
      <form ngNativeValidate>
        <div class="row g-3">
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
              Tipos de servicio:</label
            >
            <ng-select [items]="Tiposclientes" placeholder="Selecciona una opción"
          class="js-example-placeholder-multiple" [(ngModel)]="tiposclientes"></ng-select>
          </div>
  
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
              Tipos de vehiculos:</label
            >
            <ng-select [items]="TiposVehiculos" placeholder="Selecciona una opción"
          class="js-example-placeholder-multiple" [(ngModel)]="tiposvehiculos"></ng-select>
            <div class="valid-feedback">Looks good!</div>
          </div>

          <div class="col-md-3 mb-3">
            <label class="form-label" for="startDate">Fecha de inicio</label>
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="yyyy-mm-dd" name="startDate" [(ngModel)]="fromDate" ngbDatepicker #d1="ngbDatepicker" [placement]="placement" (focus)="fromDate = null" />
              <button class="btn btn-primary calendar" (click)="d1.toggle()" type="button">
                <app-feather-icons [icon]="'calendar'"></app-feather-icons>
              </button>
            </div>
          </div>

          <div class="col-md-3 mb-3">
            <label class="form-label" for="startDate">Fecha de final</label>
            <div class="input-group input-group-sm">
              <input class="form-control" placeholder="yyyy-mm-dd" name="startDate" [(ngModel)]="fromDate" ngbDatepicker #d1="ngbDatepicker" [placement]="placement" (focus)="fromDate = null" />
              <button class="btn btn-primary calendar" (click)="d1.toggle()" type="button">
                <app-feather-icons [icon]="'calendar'"></app-feather-icons>
              </button>
            </div>
          </div>
        </div>


        <div class="row g-3 mt-3">
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
             Origen:</label>
             <ng-select [items]="Origen" placeholder="Selecciona una opción"
             class="js-example-placeholder-multiple" [(ngModel)]="origen"></ng-select>
          </div>
  
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
              Destino:</label
            >
            <ng-select [items]="Destino" placeholder="Selecciona una opción"
             class="js-example-placeholder-multiple" [(ngModel)]="destino"></ng-select>
            <div class="valid-feedback">Looks good!</div>
          </div>
  
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
              Cantidad de Pasajeros:</label
            >
            <input
              class="form-control"
              id="validationCustom01"
              type="text"
              placeholder="First name"
              required=""
              onlyAlphabets
            />
            <div class="valid-feedback">Looks good!</div>
          </div>
  
          <div class="col-md-3">
            <label class="form-label" for="validationCustom01">
                Tipo de Viaje</label
            >
            <ng-select [items]="Tipoviaje" placeholder="Selecciona una opción"
          class="js-example-placeholder-multiple" [(ngModel)]="tipoviaje"></ng-select>
            <div class="valid-feedback">Looks good!</div>
          </div>
        </div>

        <div class="row g-3 mt-3">
            <div class="col-md-3">
              <label class="form-label" for="validationCustom01">
                Número de vehiculos:</label
              >
              <input
                class="form-control"
                id="validationCustom01"
                type="number"
                placeholder="First name"
                required=""
                onlyAlphabets
              />
            </div>
    
            <div class="col-md-3">
              <label class="form-label" for="validationCustom01">
                Vr unitario:</label
              >
              <input
                class="form-control"
                id="validationCustom01"
                type="number"
                placeholder="First name"
                required=""
                onlyAlphabets
              />
              <div class="valid-feedback">Looks good!</div>
            </div>
          </div>
      </form>
      <div class="d-flex justify-content-center gap-3 mt-3">
        <button class="btn btn-success d-flex align-items-center" (click)="agregarServicio()" type="button">
          <app-feather-icons [icon]="'plus'" class="me-2"></app-feather-icons>
          <span class="text-center">Agregar servicio</span>
        </button>
      </div>
    </div>
  </div>

  <div class="card" *ngIf="mostrarTabla">
    <div class="card-header d-flex align-items-center bg-primary text-white">
      <i class="icofont icofont-list me-2"></i>
      <h5 class="mb-0">Datos de Cotización</h5>
    </div>
    <div class="card-body custom-datatable noscroll">
      <div class="custom-datatable table-responsive">
        <table class="table table-responsive border border-secondary table-hover table-striped my-3">
          <thead>
            <tr>
              <th scope="col" sortable="Servicio" (sort)="onSort($event)" class="text-primary border border-secondary text-center">SERVICIO</th>
              <th scope="col" sortable="Vehiculo" (sort)="onSort($event)" class="text-primary border border-secondary text-center">VEHICULO</th>
              <th scope="col" sortable="Inicio" (sort)="onSort($event)" class="text-primary border border-secondary text-center">INICIO</th>
              <th scope="col" sortable="Fin" (sort)="onSort($event)" class="text-primary border border-secondary text-center">FIN</th>
              <th scope="col" sortable="Origen" (sort)="onSort($event)" class="text-primary border border-secondary text-center">ORIGEN</th>
              <th scope="col" sortable="Destino" (sort)="onSort($event)" class="text-primary border border-secondary text-center">DESTINO</th>
              <th scope="col" sortable="Pasajeros" (sort)="onSort($event)" class="text-primary border border-secondary text-center">PASAJEROS</th>
              <th scope="col" sortable="Viajes" (sort)="onSort($event)" class="text-primary border border-secondary text-center">VIAJE</th>
              <th scope="col" sortable="CantVehiculos" (sort)="onSort($event)" class="text-primary border border-secondary text-center">CANT VEHÍCULOS</th>
              <th scope="col" sortable="Unitario" (sort)="onSort($event)" class="text-primary border border-secondary text-center">VR UNITARIO</th>
              <th scope="col" sortable="VrServicio" (sort)="onSort($event)" class="text-primary border border-secondary text-center">VR SERVICIO</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let item of tableItem$ | async">
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Servicio" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Vehiculo" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Inicio" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Fin" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Origen" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Destino" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Pasajeros" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Viajes" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.CantVehiculos" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.Unitario" [term]="service.searchTerm"></ngb-highlight>
              </td>
              <td class="border border-secondary">
                <ngb-highlight [result]="item.VrServicio" [term]="service.searchTerm"></ngb-highlight>
              </td>

            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-between mt-3">
          <select class="form-select" style="width: 150px" name="pageSize" [(ngModel)]="service.pageSize">
            <option [ngValue]="2">2 items per page</option>
            <option [ngValue]="4">4 items per page</option>
            <option [ngValue]="6">6 items per page</option>
          </select>
          <ngb-pagination class="ms-3" [collectionSize]="(total$ | async)!" [(page)]="service.page" [pageSize]="service.pageSize"></ngb-pagination>
        </div>
      </div>
      <div class="d-flex justify-content-center gap-3 mt-3">
        <button class="btn btn-success d-flex align-items-center" type="button">
          <app-feather-icons [icon]="'check'" class="me-2"></app-feather-icons>
          <span class="text-center">Guardar Cotización</span>
        </button>
      </div>
    </div>
  </div>